import { AppBar, Toolbar, IconButton } from '@mui/material'
import { isMobile } from '../../utils/functions'
//import LogoMark from '../../assets/img/logo.svg?react'
import { Link, Outlet, useLocation, useNavigate } from 'react-router'

const is_mobile = isMobile()

const LocalLayout: React.FC = () => {
  //const is_slim = useMediaQuery('(max-width: 800px)')
  const navigate = useNavigate()
  const location = useLocation()
  const location_state = location.state as {from: string} | undefined

  return <>
    <AppBar
      position='sticky'
      color='header'
      enableColorOnDark
      elevation={0}
      sx={(theme) => ({
        boxShadow: is_mobile ? '' : '0 0 4px 0 rgba(0, 0, 0, 0.4)',
        backgroundColor: 'rgba(255, 255, 255, 0.75)',
        backdropFilter: 'blur(10px)',
        ...theme.applyStyles('dark', {
          backgroundColor: 'rgba(35, 34, 35, 0.75)',
        }),
      })}
    >
      <Toolbar>
        <IconButton
          size='large' component={Link} to='/about'
          onClick={e=> {
            if (location_state?.from) {
              e.preventDefault()
              navigate(-1)
            }
          }}
        >
          <span className='material-icons'>arrow_back</span>
        </IconButton>
        {/* 本当に消すかわかんないので一時的なやつ(2025/2/16)
        <Box sx={{
          flexGrow: 1, display: 'flex',
          justifyContent: is_slim ? 'center' : 'left',
          mr: is_slim ? 4 : 0, ml: 1,
        }}>
          <Button component={Link} to='/about' state={{from: location.pathname}}>
            <Stack spacing={1} direction='row' alignItems='center'>
              <LogoMark width='32px' height='32px' style={{marginRight: '8px'}}/>
              <span className='logo'>Metamory</span>
            </Stack>
          </Button>
        </Box>
        */}
      </Toolbar>
    </AppBar>

    <main>
      <Outlet/>
    </main>
  </>
}
export default LocalLayout